var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirplay = function SvgAirplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M31.667 27.5H35c.92 0 1.667-.746 1.667-1.667V6.667C36.667 5.747 35.92 5 35 5H5c-.92 0-1.667.746-1.667 1.667v19.166c0 .92.746 1.667 1.667 1.667h3.333M20 25l8.333 10H11.667z"
  })));
};
export default SvgAirplay;